



























































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import StoreSuketVaksinasi from "@/store/modules/SuketVaksinasi";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { storeDokter } from "@/store/modules/dokter";
import { SuketBaseWithRelationship } from "@/types/suket_vaksinasi";
import moment from "moment";
import pdf from "vue-pdf";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    pdf,
  },
})
export default class SuketVaksinasiTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  allowedUnit = ["2P"];
  suketSvc = new CommonSuket(EnSuketCategory.Vaksin);
  suketStore = StoreSuketVaksinasi;

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.Vaksin, this.dataSuket.id)
      : null;
  }

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  nama = this.pasien.nama;
  rm = this.pasien.rm;
  tgl_lahir = this.pasien.tgl_lahir;
  nik = this.pasien.nik;
  paspor = this.getPaspor();
  sex = this.pasien.jk;
  // keadaan = null;
  surat_date = new Date();
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;
  catatan = null;
  tglShowRujukan = false;
  imunisasi = [
    { vaksin: null, tgl: moment().format("YYYY-MM-DD"), batch: null },
  ];
  today = moment().format("YYYY-MM-DD");
  // number = null;
  // satuan = null;
  validasi = [(v) => !!v || "*Kolom ini harus diisi"];
  saving = false;
  showInputTujuan = true;
  loadedRatio = 0;

  getPaspor() {
    if (this.pasien && this.pasien.idcard && this.pasien.idcard.length > 0) {
      const pp = this.pasien.idcard.filter((val) => val.type == "passport");
      if (pp.length > 0) return pp[0].nomor;
    } else {
      return null;
    }
  }

  @Watch("loadedRatio")
  changeLoadedRatio(val) {
    console.log("change loaded ratio", val);
  }

  mounted() {
    this.register_id = this.dataSuket?.register_id || this.register;
    this.pasien_rm = this.dataSuket?.pasien_rm || this.pasien.rm;
    this.unit_id = this.dataSuket?.unit_id || this.user.unit_id;
    this.nama = this.pasien.nama;
    this.rm = this.pasien.rm;
    this.tgl_lahir = this.pasien.tgl_lahir;
    this.nik = this.pasien.nik;
    this.paspor = this.dataSuket?.content.paspor || this.getPaspor();
    this.sex = this.pasien.jk;
    this.imunisasi = this.dataSuket?.content.imunisasi || this.imunisasi;
    this.catatan = this.dataSuket?.content.catatan || null;
    // this.keadaan = this.dataSuket?.content.keadaan || null;
    // this.alasan = this.dataSuket?.content.alasan;
    // this.number = this.dataSuket?.content.number || null;
    // this.satuan = this.dataSuket?.content.satuan || null;
    this.surat_date = this.dataSuket?.surat_date || new Date();
    this.signee_user_id = this.dataSuket?.signee_user_id || this.user.id;
    this.creator_user_id = this.dataSuket?.creator_user_id || this.user.id;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        imunisasi: this.imunisasi,
        catatan: this.catatan,
        paspor: this.paspor,
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id,
    };
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  save() {
    if (!this.saving) {
      for (let i = 0; i < this.imunisasi.length; i++) {
        if (!this.imunisasi[i].vaksin && !this.imunisasi[i].batch) {
          this.imunisasi.splice(i, 1);
        }
      }
      this.saving = true;

      const action = this.dataSuket
        ? this.suketSvc.update(this.dataSuket.id, this.input)
        : this.suketSvc.create(this.input);

      action
        .then(() => {
          // if (this.canSign) {
          //   this.showSignatureModal();
          // }

          appModule.NoticeDelay("Berhasil Simpan");

          this.close();
          StoreSuketVaksinasi.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.expandInput = false;
  }

  @Watch("dataSuket")
  changeDataSuket(val: SuketBaseWithRelationship) {
    if (val) {
      this.register_id = val.register_id;
      this.pasien_rm = val.pasien_rm.toString();
      this.unit_id = val.unit_id;
      this.nama = this.pasien.nama;
      this.rm = this.pasien.rm;
      this.tgl_lahir = this.pasien.tgl_lahir;
      this.nik = this.pasien.nik;
      this.paspor = this.getPaspor();
      this.sex = this.pasien.jk;
      this.imunisasi = val.content.imunisasi;
      this.catatan = val.content.catatan;
      // this.number = val.content.number;
      // this.satuan = val.content.satuan;
      this.surat_date = val.surat_date;
      this.signee_user_id = val.signee_user_id;
      this.creator_user_id = val.creator_user_id;
    } else {
      this.register_id = this.register;
      this.pasien_rm = this.pasien.rm;
      this.unit_id = this.user.unit_id;
      this.nama = this.pasien.nama;
      this.rm = this.pasien.rm;
      this.tgl_lahir = this.pasien.tgl_lahir;
      this.nik = this.pasien.nik;
      this.paspor = this.getPaspor();
      this.sex = this.pasien.jk;
      (this.imunisasi = [
        { vaksin: null, tgl: moment().format("YYYY-MM-DD"), batch: null },
      ]),
        (this.catatan = null);
      // this.number = null;
      // this.satuan = null;
      this.surat_date = new Date();
      this.signee_user_id = this.user.id;
      this.creator_user_id = this.user.id;
    }
  }

  tambah() {
    // alert("oke");
    const data = {
      vaksin: null,
      tgl: moment().format("YYYY-MM-DD"),
      batch: null,
    };
    this.imunisasi.push(data);
  }
  hapus(idx) {
    this.imunisasi.splice(idx, 1);
    if (this.imunisasi.length == 0) {
      this.tambah();
    }
  }
  tglFormattedMomentjs(val) {
    return val ? moment(val).format("DD-MM-YYYY") : "";
  }

  @Watch("pasien")
  changeDataPaspor(val) {
    this.paspor = this.getPaspor();
  }

  refresh() {
    storePasien.act_pasien_last_reg(this.rm);
  }
}
